'use client';
import { useTranslations } from 'next-intl';
import { cn } from '@/app/utils';

export const LimitedTag = ({ className }: { className?: string }) => {
  const t = useTranslations();
  return (
    <div
      className={cn(
        'rounded-4 bg-[linear-gradient(0deg,rgba(76,99,255,0.48)_0%,rgba(76,99,255,0.48)_100%)] px-2 py-0.5 text-system-white text-xs leading-[1.4]',
        className,
      )}
    >
      {t('agentProject.freeLimited')}
    </div>
  );
};
